export const colorsToOverwrite = {
	"rgb(46, 204, 113)": "var(--green)",
	"rgb(0, 168, 133)": "var(--green)",
	black: "var(--black100)",
	"rgb(33, 37, 41)": "var(--green)",
	"rgb(40, 50, 78)": "var(--green)",
	"rgb(41, 105, 176)": "var(--green)",
	"#365f91": "var(--green)",
	"rgb(71, 85, 119)": "var(--green)",
	"rgb(77, 81, 86)": "var(--green)",
	"#4e5f70": "var(--green)",
	"rgb(85, 57, 130)": "var(--green)",
	"rgb(184, 49, 47)": "var(--red)",
	"rgb(226, 80, 65)": "var(--red)",
	"rgb(97, 189, 109)": "var(--green)",

	"rgb(0,71,127)": "var(--green)",
	"#00a65d": "var(--green)",
	"#16a085": "var(--green)",
	"#1abc9c": "var(--green)",
	"rgb(26, 188, 156)": "var(--green)",
	"#2980b9": "var(--green)",
	"rgb(41, 128, 185)": "var(--green)",
	"rgb(44, 130, 201)": "var(--green)",
	"#3498db": "var(--green)",
	"rgb(61, 142, 185)": "var(--green)",
	"rgb(84, 172, 210)": "var(--green)",
	"#5b9bd5": "var(--green)",

	"#000000": "var(--black100)",
	"rgb(0, 0, 0)": "var(--black100)",
	"#0d0d0d": "var(--black100)",
	"#212121": "var(--black100)",
	"#222222": "var(--black100)",
	"#242424": "var(--black100)",
	"#333333": "var(--black100)",
	"rgb(51, 51, 51)": "var(--black100)",
	"#414141": "var(--black100)",
	"rgb(65, 65, 65)": "var(--black100)",
	"#505050": "var(--black100)",
	"#555555": "var(--black100)",
	"rgb(85, 85, 85)": "var(--black100)",
	"#595959": "var(--black100)",
	"rgb(98, 98, 98)": "var(--black100)",
	"rgb(102,102,102)": "var(--black100)",
	"rgb(204, 204, 204)": "var(--black100)",
	"rgb(209, 213, 216)": "var(--black100)",

	"#008000": "var(--green)",
	"#00B050": "var(--green)",
	"#00b050": "var(--green)",
	"rgb(0, 176, 80)": "var(--green)",
	"#00cc00": "var(--green)",
	"#27ae60": "var(--green)",
	"rgb(65, 168, 95)": "var(--green)",
	"#44a921": "var(--green)",
	"#61BD6D": "var(--green)",
	"#70AD47": "var(--green)",
	"#70ad47": "var(--green)",

	"#8e44ad": "var(--orange)",
	"rgb(147, 101, 184)": "var(--orange)",
	"#9b59b6": "var(--orange)",

	"rgb(124, 112, 107)": "var(--red)",
	"rgb(163, 143, 132)": "var(--red)",
	"#c0392b": "var(--red)",
	"#c3320b": "var(--red)",
	"rgb(209, 72, 65)": "var(--red)",
	"#d35400": "var(--red)",
	"#E25041": "var(--red)",
	"#e67e22": "var(--red)",
	"#e74c3c": "var(--red)",
	"rgb(243, 121, 52)": "var(--red)",
	"#f91e00": "var(--red)",
	"#ff0000": "var(--red)",

	"rgb(236, 236, 236)": "var(--black100)",
	"rgb(237, 237, 237)": "var(--black100)",
	"rgb(239, 239, 239)": "var(--black100)",
	"#ffffff": "var(--black100)",
	"rgb(255, 255, 255)": "var(--black100)",

	"#92d050": "var(--green)",
	"#92D050": "var(--green)",
	"#f1c40f": "var(--orange)",
	"#f39c12": "var(--orange)",
	"rgb(247, 218, 100)": "var(--orange)",
	"rgb(250, 197, 28)": "var(--orange)",
	"rgb(251, 160, 38)": "var(--orange)",
	"#FFC000": "var(--orange)",
	"#ffcc00": "var(--orange)",
};
